import Manager from 'coreClasses/Manager';
import {ERecommendationsProviders} from './IRecommendationsMgr';
import RecommendationsProvider from './providers/RecommendationsProvider';
import RecommendationsProvidersFactory from './RecommendationsProvidersFactory';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents a recommendations manager
 */
export class RecommendationsMgr extends Manager {
	private factory: RecommendationsProvidersFactory;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);

		this.factory = new RecommendationsProvidersFactory(managerRepository);
	}

	/**
	 * Returns recommendations provider
	 * @param {ERecommendationsProviders} providerId Recommendations provider id
	 * @returns {RecommendationsProvider}
	 */
	getProvider(providerId: ERecommendationsProviders | null = null): RecommendationsProvider {
		if (!providerId) {
			providerId = this.managerRepository.getConfigurationsMgr().get('sitePreferences.recommendationsProvider')
				||
				'einstein';
		}

		return this.factory.create(providerId);
	}
}

export default RecommendationsMgr;
